import { render, staticRenderFns } from "./taobao_shangou_gzh.vue?vue&type=template&id=ee28217c&scoped=true&"
import script from "./taobao_shangou_gzh.vue?vue&type=script&lang=js&"
export * from "./taobao_shangou_gzh.vue?vue&type=script&lang=js&"
import style0 from "./taobao_shangou_gzh.vue?vue&type=style&index=0&id=ee28217c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee28217c",
  null
  
)

export default component.exports